import { createAction } from 'redux-starter-kit';

/**
 * An action creator for putting the credit packages into the state.
 * @param {Array} packages The packages
 * @example dispatch(putOutcome(outcome))
 */
export const putCreditPackages = createAction('PUT_CREDIT_PACKAGES');
